<template>
	<div>
		<p>
			<campaigns-tooltip-label
				tooltip="If checked, successful campaign leads will be saved to the selected MailPoet list."
				label="Save lead to MailPoet?"
			>
				<common-toggle-input
					v-model="settingMailpoet"
					class="omapi-input"
					wrapTag="span"
					onText="Yes"
					offText="No"
				/>
			</campaigns-tooltip-label>
		</p>
		<div v-if="settingMailpoet">
			<p>
				<campaigns-tooltip-label
					tooltip="All successful leads for the campaign will be added to this particular MailPoet list."
					label="Add lead to this MailPoet list:"
				>
					<select v-model="settingMpList" class="omapi-input omapi-input__select">
						<option
							v-for="(option) in mailPoetLists"
							:key="'mailPoetLists-' + option.value"
							:value="option.value"
						>
							{{ option.name }}
						</option>
					</select>
				</campaigns-tooltip-label>
			</p>
			<p>
				<campaigns-tooltip-label
					tooltip="If checked, phone number will be saved in Mailpoet."
					label="Save phone number to MailPoet?"
				>
					<common-toggle-input
						v-model="phoneEnabled"
						class="omapi-input"
						wrapTag="span"
						onText="Yes"
						offText="No"
					/>
				</campaigns-tooltip-label>
			</p>

			<p v-if="settingMpPhone || phoneEnabled">
				<campaigns-tooltip-label
					tooltip="If you have a custom field for phone numbers, select the field here."
					label="Select the custom field for phone:"
				>
					<select v-model="settingMpPhone" class="omapi-input omapi-input__select">
						<option
							v-for="(option) in mailPoetFields"
							:key="'mailPoetFields-' + option.value"
							:value="option.value"
						>
							{{ option.name }}
						</option>
					</select>
				</campaigns-tooltip-label>
			</p>
		</div>
	</div>
</template>

<script lang="js">
import { mapGetters } from 'vuex'
import { campaign } from '@/campaigns/mixins/campaign'

export default  {
	mixins : [ campaign ],
	props  : {
		campaign : {
			type     : Object,
			required : true,
		},
	},
	data () {
		return {
			phoneEnabled : false,
		}
	},
	mounted () {
		if (this.settingMpPhone) {
			this.phoneEnabled = true
		}
	},
	watch : {
		settingMpPhone (val) {
			if (val) {
				this.phoneEnabled = true
			}
		},
		phoneEnabled (newVal) {
			if (!newVal) {
				this.settingMpPhone = ''
			}
		},
	},
	computed : {
		...mapGetters('wp', [ 'mailPoetLists', 'mailPoetFields' ]),
	},
}
</script>
